


<div class="table-responsive margin-top-15 table-view">
    <h5 class="table-title">Energy & Waste Consumption By Unit</h5>
    <button class="btn btn-primary primary-btn button-excel"  style="margin-bottom: 10px;" (click)="exportToExcel()">
      <i class="fa fa-file-excel-o"></i>Export To Excel</button>
    <p-table [columns]="cols" [value]="rows" [scrollable]="false" scrollHeight="500px" dataKey="Id" editMode="row" id="EnergyWasteConsumptionUnitWiseTableToExport">
      <ng-template pTemplate="header" let-columns>
          <tr>
              <th [ngClass]="col.header =='Contract No' ? '':'center-table'" style="width: 120px;" *ngFor="let col of columns">
                <span *ngIf="col.header !='BaseUnit'">{{col.header}}</span>   
              </th>
              <!-- <th class="center-table" style="width: 60px;">Actions</th> -->
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex" let-editing="editing">
          <tr [pEditableRow]="rowData">
            <ng-container *ngFor = "let col of columns">

           
              <td   
              *ngIf="col.field === 0  &&
              rowGroupMetadata[rowData[col.field]].index === rowIndex
          "
          [attr.rowspan]="rowGroupMetadata[rowData[col.field]].size"
           
          
              [ngClass]="col.field == 1 ? '':'center-table'" style="width: 120px;"  >
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input *ngIf="col.field != 0"
                      pInputText
                      type="number"
                      [(ngModel)]="rowData[col.field]"
                      required
                    />
                    <span *ngIf="col.field == 1">{{rowData[col.field]}}</span>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span>{{rowData[col.field]}}</span>       
                  </ng-template>
                </p-cellEditor>
              </td>
              <td   
              *ngIf="col.field != 0 "
            
          
              [ngClass]="col.field == 1 ? '':'center-table'" style="width: 120px;"  >
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input *ngIf="col.field != 0"
                      pInputText
                      type="number"
                      [(ngModel)]="rowData[col.field]"
                      required
                    />
                    <span *ngIf="col.field == 1">{{rowData[col.field]}}</span>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <span>{{rowData[col.field]}}</span>       
                  </ng-template>
                </p-cellEditor>
              </td>
            </ng-container>
               
          </tr>
      </ng-template>
  </p-table>
</div>

<div class="modal fade PDModal" data-backdrop="static" style="opacity:1 !important;" id="AT" role="dialog">
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        
          <button type="button" class="close button-cancel" data-dismiss="modal">&times;</button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of EWCUnitWiseData; let i=index">
            <li><a (click)="Redirect(item.value,item.ID)">{{item.Text }}</a></li>
         </ng-container>   
        </ol>
        <span *ngIf="EWCUnitWiseData?.length < 1" style="color:red;">No Records Found..</span>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
